export default "__VITE_ASSET__DT3pf7R5__"